export default "__VITE_PUBLIC_ASSET__1684e8d6__"